<template>
  <Flex
    :class="[$style.base, { [$style.smallScreen]: $screen === 's' }]"
    :direction="$screen === 's' ? 'column' : 'row'"
    fullHeight
    :gap="0"
  >
    <Flex
      v-if="!showMobileBrowser || $screen !== 's'"
      :class="$style.sidebar"
      direction="column"
    >
      <Sidebar />
    </Flex>
    <div :class="$style.left">
      <slot name="left" />
    </div>
    <div :class="$style.right">
      <slot name="right" />
    </div>
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import { storeToRefs } from 'pinia';
import { useRegisterBrowserStore } from './browser/store';
import Sidebar from './Sidebar.vue';

const { showMobileBrowser } = storeToRefs(useRegisterBrowserStore());
</script>

<style
  lang="scss"
  module
>
.sidebar {
  .base:not(.smallScreen) & {
    min-width: 180px;
    width: 20%;
    min-height: 0;
    flex: none;
    overflow-y: auto;
  }

  .base.smallScreen & {
    border-bottom: 1px solid var(--color-border);
  }
}
.left {
  .base:not(.smallScreen) & {
    border-right: 1px solid var(--color-border);
    border-left: 1px solid var(--color-border);
    width: 35%;
    min-width: 250px;
    min-height: 0;
    flex: 1;
    overflow-y: auto;
  }

  .base.smallScreen & {
    &:not(:empty) {
      flex: 1;
      min-height: 0;
      overflow: hidden;
    }
  }
}
.right {
  background-color: var(--color-bg-secondary);

  .base:not(.smallScreen) & {
    width: 45%;
  }
}
</style>
